import { Routes } from '@angular/router';
import { devOnlyGuard } from '@guards/dev-only.guard';
import { noAuthGuard } from '@guards/no-auth.guard';
import { PublicLayoutComponent } from 'app/layout/public-layout/public-layout.component';
import { OnboardingComponent } from '../onboarding/onboarding.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { CandidateCompleteComponent } from './candidate-complete/candidate-complete.component';
import { CompanySignupComponent } from './company-signup/company-signup.component';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordConfirmComponent } from './reset-password-confirm/reset-password-confirm.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
	{
		path: '',
		component: PublicLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full',
			},
			{
				// La puerta de siempre: formulario directo, sin cajas. Es la del
				// equipo interno (que no tiene alta) y la URL a la que apuntan los
				// enlaces ya escritos — `requireSession()`, los correos y el «volver
				// al acceso» del cambio de contraseña. Ver la cabecera de
				// `LoginComponent`.
				path: 'login',
				component: LoginComponent,
				canActivate: [noAuthGuard],
			},
			{
				// Acceso de candidatos (25/08): «Inicia sesión» + «Alta candidatos».
				// Mismo componente que `/login`; lo único que cambia es `audience`.
				path: 'access/candidates',
				component: LoginComponent,
				canActivate: [noAuthGuard],
				data: { audience: 'candidate' },
			},
			{
				// Acceso de empresas: «Inicia sesión» + «Alta empresas».
				path: 'access/companies',
				component: LoginComponent,
				canActivate: [noAuthGuard],
				data: { audience: 'company' },
			},
			{
				path: 'verify-email',
				component: VerifyEmailComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password-confirm',
				component: ResetPasswordConfirmComponent,
			},
			{
				// Where every invitation lands: choose a password, session opens.
				// No `noAuthGuard` on purpose, like the reset: the link carries its
				// own session in the fragment and the screen clears whatever was
				// open before adopting the new one.
				path: 'activate-account',
				component: ActivateAccountComponent,
			},
			{
				// Lazy on purpose: the ui-kit tree is ~8k lines of dev-only showroom
				// and a static import compiled it into the public bundle for everyone.
				path: 'ui-kit',
				loadComponent: () => import('./ui-kit/ui-kit.component').then((m) => m.UiKitComponent),
				canActivate: [devOnlyGuard],
			},
			{
				// Public candidate video-completion page (Fase 3). No auth guard: the
				// single-use token in the URL is the credential.
				path: 'complete/:token',
				component: CandidateCompleteComponent,
			},
			{
				// Aviso legal, condiciones y privacidad (10/09): pública, se abre en una
				// pestaña aparte desde el login y los formularios de alta.
				path: 'legal',
				component: LegalNoticeComponent,
			},
			{
				// Alta gratuita de empresa (freemium, 13-ago). Fuera del login y sin
				// `noAuthGuard`: el enlace se pone también dentro de la plataforma,
				// y una empresa que ya ha entrado tiene que poder mandárselo a otra.
				path: 'company-signup',
				component: CompanySignupComponent,
			},
			{
				/**
				 * Alta pública de candidato: el ASISTENTE de diez pasos (23/09).
				 *
				 * Hasta ese día era el formulario corto del backoffice
				 * (`CandidateApplyComponent` con `publicIntake`), y al aprobar a la
				 * persona se la mandaba al asistente a rellenarlo todo otra vez: dos
				 * vueltas y dos pasadas por Scoring. Ahora es el mismo asistente que
				 * `/onboarding/:token`, en modo `signup`: el bloque de Documentos
				 * arriba pide el email y la privacidad, y al subir el primer fichero
				 * nace el borrador y la página sigue con su token.
				 *
				 * Sin `noAuthGuard`, igual que el alta de empresa: el enlace se
				 * comparte también desde dentro de la plataforma y alguien con
				 * sesión abierta tiene que poder mandárselo a un conocido.
				 */
				path: 'candidate-signup',
				component: OnboardingComponent,
				data: { signup: true },
			},
			{
				// M02 · ten-step onboarding by public URL. Same component as the
				// portal's "Completar perfil"; the token in the path is the
				// credential, so no guard here either.
				path: 'onboarding/:token',
				component: OnboardingComponent,
			},
		],
	},
];

export default routes;
